import { createAPI } from '../util'
import { BASE_URL } from '@/consts/const'

export default createAPI(BASE_URL)



// WEBPACK FOOTER //
// ./src/api/wfjb/instance.js